<template>
    <div class="personal_job">
        <i-row>
            <i-col span="24">
                <i-carousel autoplay loop>
                    <i-carouselItem v-for="item in slideDate">
                        <div class="carousel"><img class="carousel_img" :src="url + item.path"/></div>
                    </i-carouselItem>
                </i-carousel>
            </i-col>
        </i-row>
        <i-row class="margintop">
            <i-col span="3" offset="3" class="verticalMenu">
                <i-menu active-name="job" style="text-align: center;width: 100%;" @on-select="routeTo">
                    <i-menuGroup title="个人中心" style="padding-left: 0px;">
                        <i-menuItem name="create_team">
                            <i-icon type="md-document"/>
                            团队管理<br>
                        </i-menuItem>
                        <i-menuItem name="job">
                            <i-icon type="ios-ribbon"/>
                            提交作品<br>
                        </i-menuItem>
                        <i-menuItem name="audit">
                            <i-icon type="ios-people"/>
                            报名情况<br>
                        </i-menuItem>
                        <i-menuItem name="audit">
                        </i-menuItem>
                    </i-menuGroup>
                </i-menu>
            </i-col>
            <i-col span="16" offset="1">
                <i-form ref="formJob" :rules="ruleValidate" :model="formJob" label-position="top">
                    <i-row :gutter="48" style="margin-bottom: 15px;">
                        <!--<i-col span="5" offset="1">-->
                        <!--<form-item label="作品名称" prop="job_name">-->
                        <!--<i-input v-model="formJob.job_name" placeholder="标题"></i-input>-->
                        <!--</form-item>-->
                        <!--</i-col>-->
                        <!--<i-col span="5" offset="1">-->
                        <!--<form-item label="选题类别" prop="topic_id">-->
                        <!--<i-select v-model="formJob.topic_id">-->
                        <!--<i-option v-for="item in selectTopic"  :value="item.id" :key="item.id">{{item.topic_name}}</i-option>-->
                        <!--</i-select>-->
                        <!--</form-item>-->
                        <!--</i-col>-->
                    </i-row>

                    <i-row :gutter="48">
                        <i-col span="5" offset="1" style="height: 250px;">
                            <form-item label="参赛表格(word)" prop="one_url">
                                <i-upload
                                        :action="upurl"
                                        :max-size="5*1024"
                                        :data="{type:text_name.one_url}"
                                        :headers="{Authorization:auth,}"
                                        :format="['doc','docx']"
                                        :on-success="handleSuccess"
                                        :on-format-error="handleFormatError"
                                        :before-upload="handleBeforeUpload"
                                        :on-remove="handleRemove"
                                >
                                    <i-button icon="ios-cloud-upload-outline">参赛表格上传(max5M)</i-button>
                                    <div v-if="aliyun != a_url.one_url"><a :href="a_url.one_url"
                                                                           target="_blank">查看已提交</a></div>
                                </i-upload>
                            </form-item>
                        </i-col>
                        <i-col span="5" offset="2" style="height: 250px;">
                            <form-item label="策划案主体(pdf)" prop="two_url">
                                <i-upload
                                        :action="upurl"
                                        :max-size="10*1024"
                                        :data="{type:text_name.two_url}"
                                        :headers="{Authorization:auth}"
                                        :format="['pdf']"
                                        :on-success="handleSuccess"
                                        :on-format-error="handleFormatError"
                                        :before-upload="handleBeforeUpload"
                                        :on-remove="handleRemove"
                                >
                                    <i-button icon="ios-cloud-upload-outline">策划案主体上传(max10M)</i-button>
                                    <div v-if="aliyun != a_url.two_url"><a :href="a_url.two_url"
                                                                           target="_blank">查看已提交</a></div>
                                </i-upload>
                            </form-item>
                        </i-col>
                        <i-col span="5" offset="2" style="height: 250px;">
                            <form-item label="策划案主体(ppt)" prop="three_url">
                                <i-upload
                                        :action="upurl"
                                        :max-size="50*1024"
                                        :data="{type:text_name.three_url}"
                                        :headers="{Authorization:auth}"
                                        :format="['ppt','pptx']"
                                        :on-success="handleSuccess"
                                        :on-format-error="handleFormatError"
                                        :before-upload="handleBeforeUpload"
                                        :on-remove="handleRemove"
                                >
                                    <i-button icon="ios-cloud-upload-outline">策划案主体上传(max50M)</i-button>
                                    <div v-if="aliyun != a_url.three_url"><a :href="a_url.three_url" target="_blank">查看已提交</a>
                                    </div>
                                </i-upload>
                            </form-item>
                        </i-col>
                        <i-col span="5" offset="1" style="height: 250px;">
                            <form-item label="项目报告(pdf)" prop="four_url">
                                <i-upload
                                        :action="upurl"
                                        :max-size="10*1024"
                                        :data="{type:text_name.four_url}"
                                        :headers="{Authorization:auth}"
                                        :format="['pdf']"
                                        :on-success="handleSuccess"
                                        :on-format-error="handleFormatError"
                                        :before-upload="handleBeforeUpload"
                                        :on-remove="handleRemove"
                                >
                                    <i-button icon="ios-cloud-upload-outline">项目报告上传(max10M)</i-button>
                                    <div v-if="aliyun != a_url.four_url"><a :href="a_url.four_url"
                                                                            target="_blank">查看已提交</a></div>
                                </i-upload>
                            </form-item>
                        </i-col>
                        <i-col span="5" offset="2" style="height: 250px;">
                            <form-item label="项目报告(word)" prop="five_url">
                                <i-upload
                                        :action="upurl"
                                        :max-size="5*1024"
                                        :data="{type:text_name.five_url}"
                                        :headers="{Authorization:auth}"
                                        :format="['docx','doc']"
                                        :on-success="handleSuccess"
                                        :on-format-error="handleFormatError"
                                        :before-upload="handleBeforeUpload"
                                        :on-remove="handleRemove"
                                >
                                    <i-button icon="ios-cloud-upload-outline">项目报告上传(max5M)</i-button>
                                    <div v-if="(aliyun != a_url.five_url&&aliyun+'null' != a_url.five_url)"><a
                                            :href="a_url.five_url" target="_blank">查看已提交</a></div>
                                </i-upload>
                            </form-item>
                        </i-col>
                        <i-col span="5" offset="2" style="height: 250px;">
                            <form-item label="其它附件" prop="">
                                <!--<i-upload-->
                                <!--:action="upurl"-->
                                <!--:max-size="50*1024"-->
                                <!--:data="{type:text_name.six_url}"-->
                                <!--:headers="{Authorization:auth}"-->
                                <!--:on-success="handleSuccess"-->
                                <!--:on-format-error="handleFormatError"-->
                                <!--:before-upload="handleBeforeUpload"-->
                                <!--:on-remove="handleRemove"-->
                                <!--&gt;-->
                                <i-button icon="ios-cloud-upload-outline" @click.native="modal1 = true">其它附件上传
                                </i-button>
                                <!--<div v-if="(aliyun != a_url.six_url&&aliyun+'null' != a_url.six_url)"><a-->
                                <!--:href="a_url.six_url" target="_blank">查看已提交</a></div>-->
                                <!--</i-upload>-->
                            </form-item>
                            <form-item label="作品是否存在附件" prop="six_url">
                                <i-select v-model="formJob.six_url">
                                    <i-option  v-for="item in Enclosure" :value="item.key">{{ item.value }}</i-option>
                                </i-select>
                            </form-item>
                        </i-col>
                        <Modal
                                v-model="modal1"
                                title="提示"
                                @on-ok="ok"
                                @on-cancel="cancel">
                            <p style="font-size: 18px">请将附件于6月17日-6月21日前发送至组委会QQ邮箱：251355155@qq.com
                                ，具体要求查看网站参赛须知。有问题咨询官方qq：251355155.</p>
                        </Modal>
                        <i-col span="5" offset="2">
                            <div style="background-color: rgb(255, 205, 39);margin-top: 22px;padding: 7px;border-radius: 7px;">
                                <a href="http://cusprpc2019.cipra.org.cn/upload/doc/join.doc" download="参赛表格"
                                   style="color: #ffffff;font-weight: bold;">
                                    点击下载参赛表格
                                </a>
                            </div>
                        </i-col>
                    </i-row>

                    <i-row :gutter="48">
                        <i-col span="6" offset="9">
                            <form-item>
                                <i-button type="primary" @click="handleSubmit('formJob')" size="large" :disabled="add">
                                    添加
                                </i-button>
                                <i-button @click="handleReset('formJob')" style="margin-left: 8px" size="large">重置
                                </i-button>
                            </form-item>
                        </i-col>
                    </i-row>
                </i-form>

            </i-col>
        </i-row>
    </div>
</template>

<script>
    import {
        Icon,
        Col,
        Row,
        Carousel,
        CarouselItem,
        Menu,
        MenuGroup,
        MenuItem,
        Form,
        FormItem,
        Input,
        Select,
        Option,
        Button,
        Upload,
        Modal
    } from 'iview'
    import {api_getData} from '../../api/carousel'
    import {api_save, api_getJob} from '../../api/personal/job'
    import {api_getClass} from '../../api/personal/topic'
    import {url, root, auth_key, aliyun} from '../../config'

    export default {
        name: '',
        components: {
            'i-form': Form,
            'form-item': FormItem,
            'i-col': Col,
            'i-row': Row,
            'i-icon': Icon,
            'i-carousel': Carousel,
            'i-carouselItem': CarouselItem,
            'i-menu': Menu,
            'i-menuGroup': MenuGroup,
            'i-menuItem': MenuItem,
            'i-input': Input,
            'i-select': Select,
            'i-option': Option,
            'i-button': Button,
            'i-upload': Upload,
            'i-modal': Modal,
        },
        data() {
            return {
                modal1: false,
                slideDate: [],
                url: url,
                aliyun: aliyun,
                selectTopic: [],
                add: false,
                Enclosure:[
                    {key:0,value:'不存在'},
                    {key:1,value:'邮箱发送'},
                ],
                text_name: {
                    one_url: '1',
                    two_url: '2',
                    three_url: '3',
                    four_url: '4',
                    five_url: '5',
                    six_url: '6',
                },
                formJob: {
                    job_name: '',
                    team_id: '',
                    topic_id: '',
                    one_url: '',
                    two_url: '',
                    three_url: '',
                    four_url: '',
                    five_url: '',
                    six_url: '',
                },
                a_url: {
                    one_url: '',
                    two_url: '',
                    three_url: '',
                    four_url: '',
                    five_url: '',
                    six_url: '',
                },
                upurl: root + '/personal/job/upimg',
                auth: sessionStorage.getItem(auth_key),
                uploadList: [],
                id: undefined,
                ruleValidate: {
                    // job_name: [
                    //   {required: true, message: '作品标题不能为空', trigger: 'blur'}
                    // ],
                    // topic_id: [
                    //   // {required: true, message: '选题类别不能为空', trigger: 'blur'}
                    // ],
                    one_url: [
                        {required: true, message: '参赛表格不能为空', trigger: 'blur'}
                    ],
                    two_url: [
                        {required: true, message: '策划案主体文件不能为空', trigger: 'blur'}
                    ],
                    three_url: [
                        {required: true, message: '策划案主体文件不能为空', trigger: 'blur'}
                    ],
                    four_url: [
                        {required: true, message: '项目报告不能为空', trigger: 'blur'}
                    ],
                    five_url: [
                        {required: true, message: '项目报告不能为空', trigger: 'blur'}
                    ],
                    six_url: [
                        {required: true, message: '请选择是否存在附件'}
                    ],
                },
                msg: '',
            }
        },
        async created() {
            let _data = await api_getData('home')
            let res = _data.body
            if (res.code === 0) {
                this.slideDate = res.data
            }
        },
        mounted() {
            api_getClass().then(_data => {
                let res = _data.body
                if (res.code === 0) {
                    this.selectTopic = res.data
                }
            })
            api_getJob().then(_data => {
                let res = _data.body
                if (res.code === 0) {
                    this.formJob = res.data
                    // console.log(this.formJob)
                    this.a_url.one_url = this.aliyun + '' + res.data.one_url
                    this.a_url.two_url = this.aliyun + '' + res.data.two_url
                    this.a_url.three_url = this.aliyun + '' + res.data.three_url
                    this.a_url.four_url = this.aliyun + '' + res.data.four_url
                    this.a_url.five_url = this.aliyun + '' + res.data.five_url
                    // this.a_url.six_url = this.aliyun + '' + res.data.six_url
                    // this.a_url.six_url = res.data.six_url
                } else {
                    this.$Message.error(res.msg)
                }
            })
        },
        methods: {
            ok() {
                this.$Message.info('已关闭');
            },
            cancel() {
                this.$Message.info('已关闭');
            },
            handleSuccess(res, file) {
                if (res.code === 1) {
                    if (res.data.type == 1) {
                        this.formJob.one_url = res.data.name
                    } else if (res.data.type == 2) {
                        this.formJob.two_url = res.data.name
                    } else if (res.data.type == 3) {
                        this.formJob.three_url = res.data.name
                    } else if (res.data.type == 4) {
                        this.formJob.four_url = res.data.name
                    } else if (res.data.type == 5) {
                        this.formJob.five_url = res.data.name
                    } else if (res.data.type == 6) {
                        this.formJob.six_url = res.data.name
                    }

                } else {
                    this.$Notice.warning({
                        title: '上传失败.'
                    })
                }
            },
            handleFormatError(file) {
                this.$Notice.warning({
                    title: '文件上传错误',
                    desc: '文件格式 ' + file.name + ' 错误,请检查文件格式重新上传'
                })
            },
            handleBeforeUpload() {
                const check = this.uploadList.length < 1;
                console.log(123123);
                if (!check) {
                    this.$Notice.warning({
                        title: 'Up to five pictures can be uploaded.'
                    })
                }
                return check
            },
            handleRemove() {
                this.uploadList = []
            },
            handleSubmit(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.add = true
                        let data = this.formJob

                        api_save(data).then(_data => {
                            let res = _data.body
                            // 保存成功
                            if (res.code === 0) {
                                this.$Message.success({
                                    content: res.msg,
                                    onClose: () => {
                                        this.add = false
                                        window.location.reload()
                                        // this.$router.push({name: 'personal_job'});
                                    }
                                })
                            } else {
                                this.add = false
                                this.$Message.error({
                                    content: res.msg,
                                    onClose: () => {
                                        this.$router.push({name: 'personal_job'})
                                    }
                                })
                            }
                        })
                        // this.$Message.success('Success!');
                    } else {
                        // this.$Message.error('Fail!');
                    }
                })
            },
            handleReset(name) {
                this.$refs[name].resetFields()
            },
            routeTo(name) {
                this.$router.push({name: 'personal_' + name, params: {ver_name: name}})
            },

        }
    }
</script>

<style lang="scss">
    .personal_job {
        text-align: left;
        /*轮播图设置*/
        .carousel {
            .carousel_img {
                width: 100%;
                height: 100%;
            }
        }

        /*row间距设置*/
        .margintop {
            margin-top: 20px;
        }

        /*菜单栏start*/
        .verticalMenu {
            .ivu-menu-vertical .ivu-menu-item-group-title {
                height: 48px;
                color: #3d2404;
                line-height: 48px;
                font-size: 18px;
                padding: 0px;
                margin-top: 10px;
                border-bottom: 2px solid #ffffff;
            }

            .ivu-menu-light {
                background: #9933cc;
            }

            .ivu-menu {
                display: block;
                border-radius: 40px;
                overflow: hidden;
                color: #ffffff;
                font-size: 14px;
                position: relative;
            }

            .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
                color: #000000;
                font-weight: 600;
                background: #c34ae4;
                z-index: 2;
            }

            .ivu-menu-vertical .ivu-menu-item:hover, .ivu-menu-vertical .ivu-menu-submenu-title:hover {
                color: #3d2404;
            }

            .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after {
                content: '';
                display: block;
                width: 2px;
                position: absolute;
                top: 0;
                bottom: 0;
                right: 0;
                background: #c34ae4;
            }
        }

        /*菜单栏end*/

        /*小标题start*/
        .title_head {
            height: 30px;
            line-height: 30px;
            background: rgb(153, 51, 204);
            border-radius: 5px;
            padding-left: 30px;
            color: white;
            font-weight: 600;
            font-size: 15px;
        }

        .title_gray {
            height: 48px;
            line-height: 48px;
            width: 100%;
            background: inherit;
            font-family: '微软雅黑';
            margin-top: 60px;
            padding-left: 30px;
            font-size: 16px;
            font-weight: 600;
            border-radius: 5px;
            background-color: rgba(242, 242, 242, 1);

        }

        /*小标题end*/

    }
</style>
